import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// Important: initialize redux-injector-backed store BEFORE loading App,
// so any @dized/ui modules that inject reducers at import-time have a store.
import { store } from './app/store';
import App from './App';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

// Runtime shim: some dependencies reference `process` at runtime in the browser.
// CRA replaces process.env at build time, but ensure a minimal object exists
// to avoid "process is not defined" in dev.
;(window as any).process = (window as any).process || { env: { NODE_ENV: process.env.NODE_ENV } };

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
